/* Mercahome — carousel helper. Supports rail (scroll-snap) and slideshow modes. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRail(root) {
    var track = root.querySelector('[data-carousel-track]');
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (!track) return;

    function page() { return Math.max(track.clientWidth * 0.85, 240); }
    function update() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    prev && prev.addEventListener('click', function () { track.scrollBy({ left: -page(), behavior: 'smooth' }); });
    next && next.addEventListener('click', function () { track.scrollBy({ left: page(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initSlideshow(root) {
    var track = root.querySelector('[data-carousel-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-slide]'));
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    var dotsWrap = root.querySelector('[data-carousel-dots]');
    var pauseBtn = root.querySelector('[data-carousel-pause]');
    if (!track || slides.length < 2) return;

    var i = 0, timer = null;
    var delay = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    var dots = [];

    if (dotsWrap) {
      slides.forEach(function (s, idx) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mrc-dot';
        b.setAttribute('aria-label', 'Ir a la diapositiva ' + (idx + 1));
        b.addEventListener('click', function () { go(idx); restart(); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }

    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, idx) {
        s.classList.toggle('is-active', idx === i);
        s.setAttribute('aria-hidden', idx === i ? 'false' : 'true');
      });
      dots.forEach(function (d, idx) { d.setAttribute('aria-current', idx === i ? 'true' : 'false'); });
    }
    function start() {
      if (reduce || !delay) return;
      stop();
      timer = setInterval(function () { go(i + 1); }, delay);
      if (pauseBtn) pauseBtn.setAttribute('aria-pressed', 'false');
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    prev && prev.addEventListener('click', function () { go(i - 1); restart(); });
    next && next.addEventListener('click', function () { go(i + 1); restart(); });
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        if (timer) { stop(); pauseBtn.setAttribute('aria-pressed', 'true'); }
        else { start(); }
      });
    }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(i - 1); restart(); }
      if (e.key === 'ArrowRight') { go(i + 1); restart(); }
    });

    go(0);
    start();
  }

  function init() {
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      if (root.getAttribute('data-carousel') === 'slideshow') initSlideshow(root);
      else initRail(root);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
